class MegaMenuTabs {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.matata-megamenu__tab');
    this.panels = container.querySelectorAll('.matata-megamenu__panel');
    this.viewAll = container.closest('.matata-megamenu__inner')?.querySelector('.matata-megamenu__view-all');
    this.onTabActivate = this.onTabActivate.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('mouseenter', this.onTabActivate);
      tab.addEventListener('focus', this.onTabActivate);
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        this.activate(tab);
      });
    });
  }

  onTabActivate(event) {
    this.activate(event.currentTarget);
  }

  activate(tab) {
    const tabId = tab.dataset.tabId;
    if (!tabId) return;

    this.tabs.forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.tabId === tabId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    if (this.viewAll && tab.dataset.collectionUrl) {
      this.viewAll.setAttribute('href', tab.dataset.collectionUrl);
    }
  }

  destroy() {
    this.tabs.forEach((tab) => {
      tab.removeEventListener('mouseenter', this.onTabActivate);
      tab.removeEventListener('focus', this.onTabActivate);
    });
  }
}

const megaMenuTabInstances = new WeakMap();

function initMegaMenuTabs(root = document) {
  root.querySelectorAll('[data-mega-menu-tabs]').forEach((container) => {
    if (megaMenuTabInstances.has(container)) return;
    megaMenuTabInstances.set(container, new MegaMenuTabs(container));
  });
}

function destroyMegaMenuTabs(root = document) {
  root.querySelectorAll('[data-mega-menu-tabs]').forEach((container) => {
    const instance = megaMenuTabInstances.get(container);
    if (!instance) return;
    instance.destroy();
    megaMenuTabInstances.delete(container);
  });
}

document.addEventListener('DOMContentLoaded', () => initMegaMenuTabs());
document.addEventListener('shopify:section:load', (event) => initMegaMenuTabs(event.target));
document.addEventListener('shopify:section:unload', (event) => destroyMegaMenuTabs(event.target));
